export const tipoTrabajoLabels = {
  instalacion: 'Instalación',
  puesta_en_marcha: 'Puesta en Marcha',
  auditoria: 'Auditoría',
  mantenimiento: 'Mantenimiento',
  revision: 'Revisión',
  reparacion: 'Reparación'
};

export const workTypeColors = {
  instalacion: '#0088FE',
  puesta_en_marcha: '#00C49F',
  auditoria: '#FFBB28',
  mantenimiento: '#FF8042',
  revision: '#8884D8',
  reparacion: '#82ca9d'
};

export const getWorkTypeLabel = (tipo: string): string => {
  return tipoTrabajoLabels[tipo as keyof typeof tipoTrabajoLabels] || tipo;
};

export const getWorkTypeColor = (tipo: string): string => {
  return workTypeColors[tipo as keyof typeof workTypeColors] || '#8884D8';
};